// Skater rating columns (column K is index 10, so 0-based index for ratings is 10-24, plus OV at AB=27)
export const rateColumns = [
  'CK',  // K (10)
  'FG',  // L (11)
  'DI',  // M (12)
  'SK',  // N (13)
  'ST',  // O (14)
  'EN',  // P (15)
  'DU',  // Q (16)
  'PH',  // R (17)
  'FO',  // S (18)
  'PA',  // T (19)
  'SC',  // U (20)
  'DF',  // V (21)
  'PS',  // W (22)
  'EX',  // X (23)
  'LD',  // Y (24)
  'OV'   // AB (27)
];

// Goalie rating columns (see your mapping: G is 6, H is 7, ... S is 18, V is 21)
export const goalieRateColumns = [
  { name: 'SK', idx: 6 },   // G
  { name: 'DU', idx: 7 },   // H
  { name: 'EN', idx: 8 },   // I
  { name: 'SZ', idx: 9 },   // J
  { name: 'AG', idx: 10 },  // K
  { name: 'RB', idx: 11 },  // L
  { name: 'SC', idx: 12 },  // M
  { name: 'HS', idx: 13 },  // N
  { name: 'RT', idx: 14 },  // O
  { name: 'PH', idx: 15 },  // P
  { name: 'PS', idx: 16 },  // Q
  { name: 'EX', idx: 17 },  // R
  { name: 'LD', idx: 18 },  // S
  { name: 'OV', idx: 21 }   // V
];

export const positionMap = {
  'C': 'Center',
  'R': 'Right Wing',
  'L': 'Left Wing',
  'D': 'Defenseman'
};
